module.exports = __webpack_public_path__ + "static/6f3c78b934497f3f16fdaaa72b775d9ec56fbde4b930216338b7894ed802e55a-383cc836005937ecd747988e0fef6cf5.png";